export const ACTING_ELEMENT_ID = 'acting';
